module.exports = __webpack_public_path__ + "img/canada-colorectal-cancer-female.1eb13349.png";